/*!
 * vee-i18n v0.10.21 
 * (c) 2020 Kate Dmitrieva <katuxadmitr@gmail.com>
 * Released under the MIT License.
 */
import { extend } from 'vee-validate';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/*
  eslint-disable
    import/prefer-default-export
*/
var dict = function dict(_) {
  return {
    alpha: _('This field may only contain alphabetic characters'),
    alpha_num: _('This field may only contain alpha-numeric characters'),
    alpha_dash: _('This  field may contain alpha-numeric characters as well as dashes and underscores'),
    alpha_spaces: _('This field may only contain alphabetic characters as well as spaces'),
    between: _('This field must be between {min} and {max}'),
    confirmed: _('This field confirmation does not match'),
    digits: _('This field must be numeric and exactly contain {length} digits'),
    dimensions: _('This field must be {width} pixels by {height} pixels'),
    email: _('Enter valid e-mail'),
    decimal: _('Enter the correct number'),
    excluded: _('This field is not a valid value'),
    ext: _('This field is not a valid file'),
    image: _('This field must be an image'),
    integer: _('This field must be an integer'),
    length: _('This field must be {length} long'),
    min: _('Enter at least {length} characters'),
    min_value: _('Value can not be low then {min}'),
    max: _('Value is too large'),
    phone: _('Enter valid phone'),
    mimes: _('This field must have a valid file type'),
    numeric: _('This field may only contain numeric characters'),
    oneOf: _('This field is not a valid value'),
    regex: _('This field format is invalid'),
    required_if: _('This field is required'),
    required: _('This field is required'),
    size: _('This field size must be less than {size}KB')
  };
};

function trans(i18n, rules) {
  function _() {
    return i18n.t.apply(i18n, arguments);
  } // loop over all rules


  for (var rule in rules) {
    // add the rule
    if ({}.hasOwnProperty.call(rules, rule)) {
      extend(rule, _objectSpread2({}, rules[rule], {
        message: dict(_)[rule]
      }));
    }
  }
}

export default trans;
export { trans };
